<ng-lottie
  *ngIf="(options$ | async) as lottieOptions"
  [options]="lottieOptions"
  (animationCreated)="animationCreated($event)"
  (domLoaded)="domLoaded()"
  class="lottie-template">
</ng-lottie>
